'use strict';

const Strings = require('../../../app/shared/Strings');

// a 'c3-ish' color from the array dervied form c3's website
const C3_COLORS = [
    'rgb(31, 119, 180)',
    'rgb(255, 127, 14)',
    'rgb(44, 160, 44)',
    'rgb(214, 39, 40)',
    'rgb(148, 103, 189)',
    'rgb(140, 86, 75)',
    'rgb(227, 119, 194)',
    'rgb(127, 127, 127)',
    'rgb(240, 201, 41)',
    'rgb(23, 190, 207)',
];

const C3_COLORS_OBJ = [
    { class: 'bb-color-0', color: C3_COLORS[0], },
    { class: 'bb-color-1', color: C3_COLORS[1], },
    { class: 'bb-color-2', color: C3_COLORS[2], },
    { class: 'bb-color-3', color: C3_COLORS[3], },
    { class: 'bb-color-4', color: C3_COLORS[4], },
    { class: 'bb-color-5', color: C3_COLORS[5], },
    { class: 'bb-color-6', color: C3_COLORS[6], },
    { class: 'bb-color-7', color: C3_COLORS[7], },
    { class: 'bb-color-8', color: C3_COLORS[8], },
    { class: 'bb-color-9', color: C3_COLORS[9], },
];

// these values are derived from client/less/common/colors.less @ch-ns-* variables
// TODO import the variables directly from less?
const NON_SCORING_COLORS = [
    '#006DE5',
    '#FE8C00',
    '#FE98ED',
    '#F0C929',
    '#9467BD',
    '#8C564B',
    '#75EBFF',
    '#7F7F7F',
    '#FFD092',
    '#363636'
];

const api = {
    getC3ColorArr: function() {
        return C3_COLORS;
    },

    getC3Color: function(atIndex) {
        if (atIndex > C3_COLORS_OBJ.length - 1) {
            console.warn(`C3ColorUtil - Warning: atIndex values > ${C3_COLORS_OBJ.length - 1} return repeated color (atIndex % ${C3_COLORS_OBJ.length - 1})`);
            return C3_COLORS_OBJ[atIndex % (C3_COLORS_OBJ.length - 1)];
        }

        return C3_COLORS_OBJ[atIndex];
    },

    getRandomColor: function() { // TEMP borrowed from: https://stackoverflow.com/questions/1484506/random-color-generator
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }

        return color;
    },

    getNonScoringColorsForData: function(data) { // data = c3/bb "array of arrays" columns format
        const colors = {};
        data.forEach((col, index) => {
            const colName = col[0];
            let color;
            if (index + 1 < NON_SCORING_COLORS.length) {
                color = NON_SCORING_COLORS[index];
                // console.debug('non-random', colName, index, color);
            }
            else {
                color = api.getRandomColor();
                // console.debug('random', colName, index, color);
            }

            colors[colName] = color;
        });

        return colors;
    },

    getScoreRangeColorObj: function(locale='en') {
        // these values are derived from client/less/common/colors.less @range-* variables
        // TODO import the variables directly from less?
        return {
            [Strings[locale].analytics.score_ranges['90-100']]: '#2CA02C',
            [Strings[locale].analytics.score_ranges['80-89']]: '#F0C929',
            [Strings[locale].analytics.score_ranges['70-79']]: '#F0C929',
            [Strings[locale].analytics.score_ranges['60-69']]: '#F0C929',
            [Strings[locale].analytics.score_ranges['50-59']]: '#FF7F0E',
            [Strings[locale].analytics.score_ranges['40-49']]: '#FF7F0E',
            [Strings[locale].analytics.score_ranges['30-39']]: '#FF7F0E',
            [Strings[locale].analytics.score_ranges['20-29']]: '#FF7F0E',
            [Strings[locale].analytics.score_ranges['10-19']]: '#D62728',
            [Strings[locale].analytics.score_ranges['0-9']]: '#D62728',
        };
    },

    getScoreRangeLabelColorObj: function(locale='en') {
        return {
            [Strings[locale].analytics.score_ranges['90-100']]: '#fff',
            [Strings[locale].analytics.score_ranges['80-89']]: '#fff',
            [Strings[locale].analytics.score_ranges['70-79']]: '#fff',
            [Strings[locale].analytics.score_ranges['60-69']]: '#fff',
            [Strings[locale].analytics.score_ranges['50-59']]: '#fff',
            [Strings[locale].analytics.score_ranges['40-49']]: '#fff',
            [Strings[locale].analytics.score_ranges['30-39']]: '#fff',
            [Strings[locale].analytics.score_ranges['20-29']]: '#fff',
            [Strings[locale].analytics.score_ranges['10-19']]: '#fff',
            [Strings[locale].analytics.score_ranges['0-9']]: '#fff',
        };
    },
};

module.exports = api;